'use client';

import { useEffect } from 'react';
import { initReactI18next, useTranslation as useTransAlias } from 'react-i18next';
import i18next, { i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { useLocale } from '@/providers/I18nProvider';
import { getOptions, LANGUAGE_COOKIE, Locales, supportedLocales } from '@/i18n/settings';

const runsOnServerSide = typeof window === 'undefined';

// Initialize i18next for the client side
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend((lang: string, ns: string) => import(`@/i18n/locales/${lang}/${ns}.json`)),
  )
  .init({
    ...getOptions(),
    lng: undefined, // @NOTE: detect the language on the client
    detection: {
      order: ['cookie', 'htmlTag'],
      lookupCookie: LANGUAGE_COOKIE,
      caches: ['cookie'],
    },
    preload: runsOnServerSide ? supportedLocales : [],
  });

export function useTranslation(ns: string): {
  lng: 'ru' | 'en';
  i18n: i18n;
  t: (path: string, args?: any) => string;
} {
  const lng = useLocale();

  const translator = useTransAlias(ns);
  const { i18n } = translator;

  if (runsOnServerSide && lng && i18n.resolvedLanguage !== lng) {
    i18n.changeLanguage(lng);
  }
  useCustomTranslationImplem(i18n, lng);
  return { ...translator, lng };
}

function useCustomTranslationImplem(i18n: i18n, lng: Locales) {
  useEffect(() => {
    if (!lng || i18n.resolvedLanguage === lng) {
      return;
    }
    i18n.changeLanguage(lng);
  }, [lng, i18n]);
}
